import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { IntentInitiator } from '@40seas/entities/intents';
import { z } from 'zod';
import { CreateCheckoutIntentDto } from './create.checkout-intent.dto';

export const CreateCheckoutIntentBodySchema = z
    .object({
        checkout: z.string().or(CreateCheckoutIntentDto['schema']),
        initiator: EnumSchema(IntentInitiator).optional(),
    })
    .strict()
    .openapi({ ref: 'CreateCheckoutIntentBody' });

export class CreateCheckoutIntentBodyDto extends FromSchema(CreateCheckoutIntentBodySchema) {
    checkout: string | CreateCheckoutIntentDto;
    initiator?: IntentInitiator;
}
